import { render } from "./profilDetails.vue?vue&type=template&id=520c75f4"
import script from "./profilDetails.vue?vue&type=script&lang=js"
export * from "./profilDetails.vue?vue&type=script&lang=js"

import "./profilDetails.vue?vue&type=style&index=0&id=520c75f4&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__